module.exports = __webpack_public_path__ + "@/assets/img/039-girl-21.1ccf133c.svg";